import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { response as res } from 'src/app/app.service';
import { environment as env } from 'src/environments/environment';

export enum Classification {
  HOME = 1,
  VIDEO = 2,
  CLINIC = 3,
  SHOPS = 4
}

@Injectable({
  providedIn: 'root'
})
export class DoctorProfileService {

  api: string = env.baseUrl + "HcpRequest";

  constructor(private http: HttpClient) { }

  getDoctorById = (id: Number) => this.http.get<res>(this.api + `/${id}`)

  getMedicalServiceByClassification = id => this.http.get<any>(env.baseUrl + "MedicalService/GetByClassification?classification=" + id)

  getDatSlot = (obj) => this.http.get<any>(env.baseUrl + "DaySlot?", { params: obj })

  searchPosts = (req: FormData) => this.http.post<any>(env.baseUrl + "SocialMedia/Posts/List", req);

  searchPostsListSSR = (req: Object) => this.http.post<any>(env.baseUrl + "SocialMedia/Posts/ListSSR", req);

  getPostById = (id: number) => this.http.get<any>(env.baseUrl + "SocialMedia/Posts/Get/" + id);

  likePost = (id: number) => this.http.get<any>(env.baseUrl + "SocialMedia/Posts/LikePost/" + id);

  unlikePost = (id: number) => this.http.delete<any>(env.baseUrl + "SocialMedia/Posts/UnLikePost/" + id);

  createDynamicLink = (req: Object) => this.http.post<any>("https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyByGefpW2cKUQotHB1tLFmbe14e3KTbCsI", req)


}
